import { Component, OnInit, trigger, style, animate, transition, state } from '@angular/core';

@Component({
    selector: 'inspired',
    template: require('./InspiredComponent.html'),
    styles: [require('./InspiredComponent.sass')],
    animations: [
        trigger('openClose', [
            state('open', style({
                display: 'block',
                position: 'relative',
                zIndex: '10',
                opacity: '1',
            })),
            state('closed', style({
                height: '0',
                display: 'none',
                opacity: '0',
                overflow: 'hidden',
            })),
            transition('open <=> closed', [
                animate('300ms')
            ])
        ]),
    ],
})

export class InspiredComponent {
    private isShowContent: {};
    constructor() { }

    ngOnInit() {
        this.isShowContent = {
            isShowContentEurope: false,
            isShowContentAfrica: false,
            isShowContentAsia: false,
            isShowContentLatin: false,
        }
    }
    showContent(key: number) {
        for (let k in this.isShowContent) {
            if ("" + k === Object.keys(this.isShowContent)[key]) {
                this.isShowContent[k] = !this.isShowContent[k];
            }
            else {
                this.isShowContent[k] = false;
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/common/modules/core/components/inspired/InspiredComponent.ts